module.exports = __webpack_public_path__ + "img/amex_h.50e1ac50.png";